import { render, staticRenderFns } from "./StudentViewTabInformation.vue?vue&type=template&id=13903aa7&"
import script from "./StudentViewTabInformation.vue?vue&type=script&lang=js&"
export * from "./StudentViewTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./StudentViewTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports